import P from '../components/texts/p/P';
import { formatCuit, formatCurrency } from '../utils/Masks';

export interface ProtectorRow {
  id: number;
  name: string;
  cuit: string;
  amount: number;
  integrated: number;
  percentage: number;
}

export function getProtectorColumns(handleRowClicked?: (row: ProtectorRow) => void) {
  return [
    {
      name: 'Documento',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {row.cuit}
          </P>
        </div>
      ),
      minWidth: '140px',
      sortable: true,
      sortField: 'cuit',
    },
    {
      name: 'Nombre',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {row.name}
          </P>
        </div>
      ),
      minWidth: '200px',
      grow: 1,
    },
    {
      name: 'Aporte',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {formatCurrency(row.amount ?? 0, true)}
          </P>
        </div>
      ),
      minWidth: '160px',
      sortable: true,
      sortField: 'amount',
    },
    {
      name: 'Integrado',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {formatCurrency(row.integrated ?? 0, true)}
          </P>
        </div>
      ),
      minWidth: '160px',
      sortable: true,
      sortField: 'integrated',
    },
    {
      name: '% de aporte sobre el fondo integrado',
      cell: (row: ProtectorRow) => (
        <div onClick={() => handleRowClicked?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
          <P type='3' variant='neutral'>
            {`${row.percentage?.toFixed(2)} %`}
          </P>
        </div>
      ),
      minWidth: '220px',
    },
  ];
}


